import { useMemo } from 'react';
import { useStoreActions, useStoreApi } from "../store/store-context";
import { selectors } from "../store/state-selectors";

/** Returns functions that make requests to the back-end for service-template CRUD API. */
export const useServiceTemplateApi = () => {
  const {
    getState
  } = useStoreApi();
  const {
    api,
    updateBusinessClientData
  } = useStoreActions();

  const getBusinessId = () => selectors.user.businessId(getState());

  return useMemo(() => {
    async function updateModifiedAServiceTemplate(value) {
      const bid = getBusinessId();
      const {
        modifiedAServiceTemplate
      } = selectors.user.businessClientData(getState(), bid) || {};

      if (bid && !modifiedAServiceTemplate) {
        await updateBusinessClientData(bid, {
          modifiedAServiceTemplate: true
        });
      }

      return value;
    }

    return {
      get() {
        let {
          includeDeleted = false,
          includeAdhocCharges = false
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return api.serviceTemplate.getAll(getBusinessId(), {
          includeDeleted,
          includeAdhocCharges
        });
      },

      create(serviceTemplate) {
        return api.serviceTemplate.create(serviceTemplate, getBusinessId()).then(updateModifiedAServiceTemplate);
      },

      update(serviceTemplate) {
        return api.serviceTemplate.update(serviceTemplate, getBusinessId()).then(updateModifiedAServiceTemplate);
      },

      delete(id) {
        return api.serviceTemplate.delete(id, getBusinessId());
      }

    };
  }, []);
};